<header [class.sesion-impersonada]="esImpersonado" id="header" class="header fixed-top d-flex align-items-center">
  <div class="header-start">
    <a routerLink="/dashboard" class="app-brand" aria-label="A2 Hacienda, inicio">
      <span class="brand-mark" aria-hidden="true">A2</span>
      <span class="brand-copy"><span class="brand-name">Hacienda</span><span class="brand-description">Gestión de documentos electrónicos</span></span>
    </a>
    <button type="button" (click)="sidebarToggle()" class="btn btn-sm sidebar-toggle" aria-label="Mostrar u ocultar menú" aria-controls="sidebar">
      <i class="bi bi-list" aria-hidden="true"></i>
    </button>
  </div>
  @if (esImpersonado) {
    <button type="button" class="impersonacion-volver" (click)="finalizarImpersonacion()" [disabled]="regresando"
      [title]="'Sesión impersonada: ' + nombreUsuario + '. Volver al usuario original'" aria-label="Finalizar impersonación y volver al usuario original">
      <i class="bi bi-person-badge" aria-hidden="true"></i><span>Sesión impersonada · Volver</span>
    </button>
  }
  <div class="header-account" [title]="nombreCuenta">
    <i class="bi bi-building" aria-hidden="true"></i><span>{{ nombreCuenta }}</span>
  </div>
  <nav class="header-nav ms-auto">
    <ul class="d-flex align-items-center">
      <li class="nav-item dropdown pe-3">
        <a class="nav-link nav-profile d-flex align-items-center pe-0" aria-label="Menú de usuario" href="#" data-bs-toggle="dropdown">
          <i class="bi bi-person-circle"></i>
          <span class="d-none d-md-block dropdown-toggle ps-2">{{ nombreUsuario }}</span>
        </a>
        <ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
          <li class="dropdown-header">
            <h6>{{ nombreUsuario }}</h6>
            <span>{{ nombreRol }}</span
            ><br />
            <small
              ><b>{{ nombreCuenta }}</b></small
            ><br />
            <small
              ><i>A2 Hacienda {{ version }}</i></small
            >
          </li>
          <li>
            <hr class="dropdown-divider" />
          </li>
          <li>
            <a class="dropdown-item d-flex align-items-center" routerLink="/configuracion/cuenta"
              ><i class="bi bi-gear"></i><span>Configuración de cuenta</span></a
            >
          </li>
          <li>
            <a class="dropdown-item d-flex align-items-center" routerLink="/contactanos"
              ><i class="bi bi-envelope"></i><span>Contáctenos</span></a
            >
          </li>
          <li>
            <a class="dropdown-item d-flex align-items-center" (click)="cambiarContrasena()">
              <i class="bi bi-key"></i><span>Cambiar contraseña</span>
            </a>
          </li>
          <li>
            <hr class="dropdown-divider" />
          </li>
          @if (esImpersonado) {
            <li><button type="button" class="dropdown-item d-flex align-items-center" (click)="finalizarImpersonacion()" [disabled]="regresando">
              <i class="bi bi-arrow-return-left"></i><span>Finalizar impersonación</span>
            </button></li>
          }
          @if (esAdministrador && !esImpersonado) {
            <li>
              <a class="dropdown-item d-flex align-items-center" (click)="cambiarCuenta()">
                <i class="bi bi-arrow-return-left"></i><span>Cambiar cuenta</span>
              </a>
            </li>
          }
          <li>
            <a class="dropdown-item d-flex align-items-center" (click)="logout()">
              <i class="bi bi-box-arrow-right"></i><span>Cerrar sesion</span>
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </nav>
</header>
